/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagTagidLangsId200,
  GetApiV1TagTagidLangsId401,
  GetApiV1TagTagidLangsId404,
  GetApiV1TagTagidLangsId500,
  GetApiV1TagTagidLangsIdPathParams,
  GetApiV1TagTagidLangsIdQueryResponse,
} from "../../types/tagIdiomasController/GetApiV1TagTagidLangsId.ts";
import { tagLangViewModelSchema } from "../tagLangViewModelSchema.ts";

export const getApiV1TagTagidLangsIdPathParamsSchema = z.object({
  tagId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1TagTagidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagTagidLangsId200Schema = z.lazy(
  () => tagLangViewModelSchema,
) as unknown as ToZod<GetApiV1TagTagidLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagTagidLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1TagTagidLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagTagidLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1TagTagidLangsId500>;

export const getApiV1TagTagidLangsIdQueryResponseSchema = z.lazy(
  () => getApiV1TagTagidLangsId200Schema,
) as unknown as ToZod<GetApiV1TagTagidLangsIdQueryResponse>;
